/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 $(document).ready(function(){
    // if (window.location.pathname.includes("/staffstart/coordinates/")) {
    //     $.getScript('https://maisonspecialms.rec.edirium.co.jp/scripts/recommender.js', function(){
    //        var params = {
    //          serv:'maisonspecialms',
    //          area:'coordinate',
    //          item:location.pathname.split('/').slice(-1)[0],
    //          n:'0'
    //        };
    //        edirium_rec.retrieve_recs(params, edirium_rec.cb.nop);
    //     });
    // }
    $(".showPopup").click(function() {
         var popupContent = $(this).closest(".line-item").find(".wk-button");
        $(".overlay").fadeIn();
        $(".popup").fadeIn();
      $("body").css("overflow", "hidden");
      $(".action").click(function() {
          console.log(true);
            $(popupContent).trigger("click");
            $(".overlay").fadeOut();
            $(".popup").fadeOut();
          $("body").css("overflow", "auto");
        });
    });
   $(".overlay").click(function() {
    
        $(".overlay").fadeOut();
        $(".popup").fadeOut();
       $("body").css("overflow", "auto");
    });
    $(".popup .drawer__close-button").click(function() {
    
        $(".overlay").fadeOut();
        $(".popup").fadeOut();
       $("body").css("overflow", "auto");
    });
    if ($('.product-facet__meta-bar').length){
        $(window).on('scroll', function () {
          if (($(window).scrollTop() + $('.product-facet__meta-bar').height()) > $('.product-facet__product-list').offset().top ){
            $('.product-facet__meta-bar').addClass('is-toolbar-scroll');
          } else {
            $('.product-facet__meta-bar').removeClass('is-toolbar-scroll');
          }
        });
    }

    // clear filters
    try{
        FilterApi.afterCall = function(filter) {
          // window.scrollTo(0,0)
          setTimeout(function() {
            if($('.boost-pfs-filter-clear-all').length > -1){
              $('#js-resetFilter').click(function(){
                $('.boost-pfs-filter-clear-all').trigger('click');
              });
            }
          }, 0);
     
          if(filter.event_type == 'collection'){
            location.reload();
          }
     
        }

      }catch(err){
        //console.log(err);
      }


   // Slick slider section slider-image.liquid
    $('.c-slider-image__list').slick({
    dots: false,
    arrows: false,
    slidesToShow: 2.72,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
      responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.45,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false
      }
    }
  ]
  });

  $('.video-wrapper__inner.video-mb').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        dots: true
      }
    }
  ]
  });

  // Slick slider section store-addresses.liquid
  $('.c-store__list-image').slick({
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    nextArrow: '<span class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13.023" height="7.183" viewBox="0 0 13.023 7.183"><g transform="translate(0 0.39)"><path d="M1420.62,231.5h11.691" transform="translate(-1420.62 -228.325)" fill="none" stroke="#000" stroke-width="1.1"/><path d="M1433.283,227.852l3.2,3.2-3.2,3.2" transform="translate(-1424.24 -227.853)" fill="none" stroke="#000" stroke-width="1.1"/></g></svg></span>',
    prevArrow: '<span class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="13.023" height="7.183" viewBox="0 0 13.023 7.183"><g  transform="translate(0.778 0.388)"><path d="M1432.311,231.5H1420.62" transform="translate(-1420.066 -228.324)" fill="none" stroke="#000" stroke-width="1.1"/><path d="M1436.485,227.852l-3.2,3.2,3.2,3.2" transform="translate(-1433.283 -227.851)" fill="none" stroke="#000" stroke-width="1.1"/></g></svg></span>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: true
      }
    }
  ]
  });
   
//sticky header
    var paramHeader = $('.shopify-section--header').outerHeight();
	var scrollThreshold = 10;
	var $header = $('.shopify-section--header .header');
    $(window).scroll(function(){
      if($(window).scrollTop() <= paramHeader && jQuery(window).scrollTop() <= 0){
      	$header.removeClass('c-header-dropdown');
      }
      else{
        if($(window).scrollTop() > paramHeader && jQuery(window).scrollTop() > 0){
        	$header.addClass('c-header-dropdown');
        }
      }
    });
// men and women
    var bannerHeight = $('.c-banner-special').outerHeight();
    var bannerLanding = $(".shopify-section--banner-landing").outerHeight();
    var bannerSlide = $(".shopify-section--slideshow").outerHeight();
	var $headerwomen = $('.page--gender_women .shopify-section--header');
	var $headermen = $('.page--gender_men .shopify-section--header');
    $(window).scroll(function(){
      if($(window).scrollTop() <= bannerHeight){
      	$headerwomen.removeClass('c-dropdown--page');
        $headermen.removeClass('c-dropdown--page');
      }
      else{
        if($(window).scrollTop() > bannerHeight){
        	$headerwomen.addClass('c-dropdown--page');
            $headermen.addClass('c-dropdown--page');
        }
      }
    });
    $(window).scroll(function(){
      if($(window).scrollTop() <= bannerLanding){
      	$headerwomen.removeClass('c-dropdown--page');
        $headermen.removeClass('c-dropdown--page');
      }
      else{
        if($(window).scrollTop() > bannerLanding){
        	$headerwomen.addClass('c-dropdown--page');
            $headermen.addClass('c-dropdown--page');
        }
      }
    });
    $(window).scroll(function(){
      if($(window).scrollTop() <= bannerSlide){
      	$headerwomen.removeClass('c-dropdown--page');
        $headermen.removeClass('c-dropdown--page');
      }
      else{
        if($(window).scrollTop() > bannerSlide){
        	$headerwomen.addClass('c-dropdown--page');
            $headermen.addClass('c-dropdown--page');
        }
      }
    });
// slick top
  $('.template-index .c-banner__item.is-mb .c-banner__item-container').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000
  });

   // slick show thumbnail
   if ($('.js-clickShowThumbnail').length > 0) {
     $('.js-clickShowThumbnail').click(function () {
       const idThumbnail = $(this).find('img').attr('alt');
       $('.product__thumbnail-list-inner .product__thumbnail-item[data-media-id='+idThumbnail+']').click();
     })
   }
   // Line restock
    
    $('.js-showLinePopup').click(function () {
      const $item = $('#oc-restock-button');
      const variantId = $(this).data("variant-id");
      $item.trigger('click');
      setTimeout(function () {
        $('#oc-restock-variant-selector option').map(function () {
          const variantIdLine = $(this).val();
    
          if ( variantIdLine == variantId ) {
            $(this).prop('selected', true);
            $(this).parent().change();
          }
        })
      },0)
      
    })


    // Control hide/show styling related
    const controlElements = document.querySelectorAll('.c-control-stylingRelated');
    if (controlElements.length > 0) {
        controlElements.forEach(element => {
            element.addEventListener('click', () => {
                const parentElement = element.parentElement;
                const productItemRelated = parentElement.querySelector('.c-productItemRelated');
    
                if (productItemRelated) {
                    if (productItemRelated.classList.contains('is-hide')) {
                        productItemRelated.classList.remove('is-hide');
                        element.querySelector('.c-control-stylingRelated__text').textContent = "CLOSE";
                    } else {
                        productItemRelated.classList.add('is-hide');
                        element.querySelector('.c-control-stylingRelated__text').textContent = "SHOW PRODUCTS";
                    }
                }
            });
        });
    }


 });

window.onload = function() {
  function foo() {
    $('#staffstart-shopify-app-container .cgpajZ .ciwbCw .hqFZpw[value="3"]').remove();
    }
  setInterval(foo, 100);
}

const arrAnimate = document.querySelectorAll('.c-animate-on-scroll');
if(arrAnimate.length > 0){
  window.addEventListener('scroll', handleScrollAnimation);
  handleScrollAnimation();
}
function handleScrollAnimation() {
  arrAnimate.forEach(item => {
    const itemPosition = item.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;

    if (itemPosition + 200 < windowHeight) {
      item.classList.add('is-show');
    }
  });
}


// LEEP NEWタグ
const NEW_TAG_DAYS = 30;
const NEW_TAG_TEXT = 'NEW';
const DELAY_MS = 1000;

function addNewTags() {
  const dateElements = document.querySelectorAll('.LeeepListDate');
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const cutoffDate = new Date(today);
  cutoffDate.setDate(today.getDate() - NEW_TAG_DAYS);

  dateElements.forEach((element) => {
    // 要素のテキスト内容を取得
    const dateText = element.textContent.trim();
    
    const [year, month, day] = dateText.split('/').map(Number);
    const elementDate = new Date(year, month - 1, day);
    elementDate.setHours(0, 0, 0, 0);
    
    // 日付を比較
    if (elementDate >= cutoffDate && elementDate <= today) {
      // NEWタグを追加
      const newLabel = document.createElement('span');
      newLabel.textContent = ` ${NEW_TAG_TEXT}`;
      newLabel.className = 'new-tag';
      element.appendChild(newLabel);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    addNewTags();
  }, DELAY_MS);
});